import React from 'react';
import { Grid2, Typography } from '@mui/material';
import { UploadedFileView } from 'components/shared/UploadedFileView/UploadedFileView';
import { BroadcastAttachment } from 'modules/broadcasts/types';

interface Props {
  attachments: any[];
  removeAttachment: (attachment: BroadcastAttachment, idx: number) => void;
}

export const AttachmentsSection = ({ attachments, removeAttachment }: Props) => {
  if (attachments.length === 0) return null;

  return (
    <Grid2 container spacing={2}>
      <Grid2 size={12}>
        <Typography variant="subtitle2" component="span">
          Attachments
        </Typography>
      </Grid2>
      {attachments.map((attachment, idx) => (
        <Grid2 key={attachment.id} size={6}>
          <UploadedFileView onDelete={() => removeAttachment(attachment, idx)} name={attachment.name} />
        </Grid2>
      ))}
    </Grid2>
  );
};
